if (!customElements.get('ecostal-downloads')) {
  class ecostalDownloads extends HTMLElement {
    constructor() {
      super();
      const toggleButton = this.querySelector('.js-see-all');
      const mobileClose = this.parentElement.parentElement.querySelector('.js-close-mobile');
      const backdropItem = this.parentElement.parentElement.querySelector('.js-download-backdrop');
      const container = this.parentElement.parentElement.querySelector('.js-download-container');
      
      if (toggleButton && container) {
        // Store original text
        this.originalText = toggleButton.textContent.trim();
        
        toggleButton.addEventListener('click', () => {
          this.toggleDownloads(toggleButton, container);
          this.toggleBackdrop(backdropItem, container);
        });
        
        mobileClose.addEventListener('click', () => {
          this.toggleDownloads(toggleButton, container);
          this.toggleBackdrop(backdropItem, container);
        });
      }
    }
    
    toggleDownloads(button, container) {
      const isExpanded = container.classList.contains('is-expanded');
      const isMobile = window.innerWidth <= 991;
      
      if (isExpanded) {
        // Collapse
        const handleTransitionEnd = () => {
          container.classList.remove('is-expanded');
          container.removeEventListener('transitionend', handleTransitionEnd);
        };
        if (isMobile) {
          container.classList.remove('is-expanded');
        } else {
          container.style.height = '0';
          container.addEventListener('transitionend', handleTransitionEnd);
        }
        button.textContent = this.originalText;
      } else {
        // Expand
        if (isMobile) {
          container.style.height = '100%';
          container.classList.add('is-expanded');
        } else {
          const fullHeight = container.scrollHeight;
          container.style.height = `${fullHeight}px`;
          container.classList.add('is-expanded');
        }
        
        const lessText = button.dataset.lessText || window.translations?.downloads?.show_less;
        button.textContent = lessText;
      }
    }
    
    toggleBackdrop(backdrop, container) {
      const isExpanded = container.classList.contains('is-expanded');
      const isMobile = window.innerWidth <= 991;
      
      if (isMobile) {
        if (isExpanded) {
          backdrop.classList.add('show');
        } else {
          backdrop.classList.remove('show');
        }
      }
    }
  }
  
  customElements.define('ecostal-downloads', ecostalDownloads);
}